import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 10h12v2H4zm0-4h12v2H4zm0 8h8v2H4zm10 0v6l5-3z"
}), 'PlaylistPlay');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PlaylistPlay.js
// module id = 5532
// module chunks = 2